import type { ProcessingState } from "@redux/state/shared-types";
import { approveExternalProviderPayment, resetApproveExternalProviderPayment } from "./approve-external-provider-payment";
import { createReducer } from "@reduxjs/toolkit";

const initialState: ProcessingState = { processing: "idle" };

export const approveExternalProviderPaymentReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(approveExternalProviderPayment.fulfilled, state => {
      return {
        ...state,
        processing: "success",
      };
    })
    .addCase(approveExternalProviderPayment.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(approveExternalProviderPayment.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetApproveExternalProviderPayment, () => {
    return initialState;
  });
});
